import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const kimai = defineConnector({
  identifier: "kimai",
  name: "Kimai",
  tagLine: "Time tracking application",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://.*.kimai.cloud/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Enter your Kimai instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "your-instance.kimai.cloud",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Kimai, go to your **Profile › API Access** and create a new API token. See the [API docs](https://www.kimai.org/documentation/rest-api.html) for details.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/timesheets`,
  },
});
